import { zodResolver } from '@hookform/resolvers/zod'
import { z } from 'zod'

import type { RepeatableTaskForm } from '@/modules/tasks/service/repeatable-task-service'
import type { List } from '@/modules/tasks/service/task-list-service'
import type { TaskForm } from '@/modules/tasks/service/task-service'

export type TaskEditorValues = TaskForm &
  RepeatableTaskForm & {
    taskList: List | null
    id: number | null
  }

export const defaultValues: TaskEditorValues = {
  name: '',
  dueDate: null,
  detail: '',
  priority: 'Medium',
  assignees: [],
  taskList: null,
  completed: false,
  period: null,
  end: null,
  start: null,
  rate: null,
  hourlyDueDuration: 0,
  id: null,
}

export const resolver = zodResolver(
  z.object({
    id: z.number().nullish().optional(),
    name: z.string().min(1, { message: 'Task title is required.' }),
    detail: z.string().nullish().optional().default(''),
    priority: z.string().nullish(),
    assignees: z.array(z.number()),
    period: z.string().nullish(),
    dueDate: z.string().nullish(),
    rate: z.array(z.number()).nullish(),
    hourlyDueDuration: z.number().nullish(),
    taskList: z
      .object({
        id: z.number(),
      })
      .optional()
      .nullish(),
  }),
)
